import tw, { css, styled } from 'twin.macro';

import type { PageVariant } from '../Page.types';
import { isViewportPageVariant } from '../pageVariantGuards';

export const StyledContent = tw.section`mx-auto max-w-[1200px] p-4 sm:p-6`;

type StyledPageContentProps = { $pageVariant: PageVariant };

export const StyledPageContent = styled(StyledContent)<StyledPageContentProps>`
	${({ $pageVariant }) =>
		isViewportPageVariant($pageVariant) &&
		css`
			${tw`z-10 flex flex-1 items-center`}
		`}
	${({ $pageVariant }) =>
		$pageVariant === 'viewportCentered' &&
		css`
			${tw`justify-center`}
		`}
`;

export const StyledContainer = styled.div`
	${tw`absolute inset-0 flex items-center justify-center bg-gray-50`}

	${css`
		z-index: 0;
		&::before {
			z-index: -1;
			position: absolute;
			content: '';
			top: 0;
			${tw`h-1/3 w-full bg-white`}
		}
		&::after {
			z-index: -1;
			position: absolute;
			content: '';
			top: calc(100% / 3);
			border-bottom: 24vw solid transparent;
			border-left: 100vw solid white;
		}
	`}
`;

export const StyledGraphics = styled.div`
	position: absolute;
	width: 100%;
	bottom: 0;
	z-index: -2;

	&::before {
		content: '';
		width: 100vw;
		height: calc(451 / 1681 * 100vw);
		left: 0;
		bottom: 0;
		background-image: url("data:image/svg+xml,%3Csvg width='1681' height='451' viewBox='0 0 1681 451' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M416 14C425.065 14 425.065 1 434.083 1C443.148 1 443.148 14 452.167 14C461.232 14 461.232 1 470.25 1C479.315 1 479.315 14 488.333 14C497.398 14 497.398 1 506.417 1C515.482 1 515.482 14 524.5 14C533.565 14 533.565 1 542.583 1C551.648 1 551.648 14 560.667 14C569.732 14 569.732 1 578.75 1C587.815 1 587.815 14 596.833 14C605.898 14 605.898 1 614.917 1C623.982 1 623.982 14 633 14' stroke='%23DAE2ED' stroke-miterlimit='10'/%3E%3Cpath d='M0 323.496C12.9098 328.347 26.895 331 41.5 331C106.67 331 159.5 278.17 159.5 213C159.5 147.83 106.67 95 41.5 95C26.895 95 12.9098 97.6534 0 102.504' stroke='%23DAE2ED'/%3E%3Cpath d='M510.919 450.5C466.962 291.637 321.352 175 148.5 175C95.7592 175 45.5546 185.859 0 205.463' stroke='%23DAE2ED'/%3E%3Cpath d='M1214 248C1224.61 248 1224.61 233 1235.17 233C1245.78 233 1245.78 248 1256.33 248C1266.94 248 1266.94 233 1277.5 233C1288.11 233 1288.11 248 1298.67 248C1309.28 248 1309.28 233 1319.83 233C1330.44 233 1330.44 248 1341 248C1351.61 248 1351.61 233 1362.17 233C1372.78 233 1372.78 248 1383.33 248C1393.94 248 1393.94 233 1404.5 233C1415.11 233 1415.11 248 1425.67 248C1436.28 248 1436.28 233 1446.83 233C1457.44 233 1457.44 248 1468 248' stroke='%23DAE2ED' stroke-miterlimit='10'/%3E%3Cpath d='M1680.5 40H1475C1400.44 40 1340 100.442 1340 175V175C1340 249.558 1400.45 310 1475.01 310C1539.49 310 1599.03 310 1680.5 310' stroke='%23DAE2ED'/%3E%3Cpath d='M1680.5 407C1621.13 407 1573 358.871 1573 299.5C1573 240.129 1621.13 192 1680.5 192' stroke='%23DAE2ED'/%3E%3C/svg%3E%0A");
		position: absolute;
		background-size: contain;
		background-repeat: no-repeat;

		@media (max-width: 900px) {
			width: 100%;
			height: 224px;
			background-image: url("data:image/svg+xml,%3Csvg width='412' height='224' viewBox='0 0 412 224' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M258 62C264.433 62 264.433 53 270.833 53C277.267 53 277.267 62 283.667 62C290.1 62 290.1 53 296.5 53C302.933 53 302.933 62 309.333 62C315.767 62 315.767 53 322.167 53C328.6 53 328.6 62 335 62C341.433 62 341.433 53 347.833 53C354.267 53 354.267 62 360.667 62C367.1 62 367.1 53 373.5 53C379.933 53 379.933 62 386.333 62C392.767 62 392.767 53 399.167 53C405.6 53 405.6 62 412 62' stroke='%23DAE2ED' stroke-miterlimit='10'/%3E%3Cpath d='M0 10.4782C16.2687 4.35129 33.8928 1 52.2978 1C134.424 1 201 67.7267 201 150.038C201 176.955 193.881 202.205 181.426 224' stroke='%23DAE2ED'/%3E%3Cpath d='M289 224C264.136 134.045 181.772 68 83.9987 68C54.166 68 25.7679 74.1487 0 85.2492' stroke='%23DAE2ED'/%3E%3C/svg%3E");
			background-position: bottom left;
		}
	}
`;
